import { buttonStyles, buttonLoadingEffect } from "./buttons";
import { rawColorValues } from "./colors";
import { LinkVariants, HeadingRegularVariants, TextVariants, Colors } from "./enums";
export const ThemeLinks = {
    [LinkVariants.standard]: {
        transition: "color 0.1s ease-in",
        color: "blue.0",
        textDecoration: "underline",
        "&:hover": {
            color: "blue.2"
        },
        "&:active": {
            color: "blue.2"
        }
    },
    [LinkVariants.standardNoUnderline]: {
        transition: "color 0.1s ease-in",
        color: "blue.0",
        textDecoration: "none",
        "&:hover": {
            color: "blue.2"
        },
        "&:active": {
            color: "blue.2"
        }
    },
    [LinkVariants.navBar]: {
        variant: "text.label2",
        color: "inherit",
        textDecoration: "none",
        borderBottom: "1px solid",
        borderColor: ["grey.3", null, null, "transparent"],
        py: 8,
        "&:hover": {
            color: "blue.0",
            borderBottom: "1px solid"
        },
        "&.active": {
            color: "blue.0",
            borderBottom: "1px solid"
        }
    },
    [LinkVariants.link_h6]: {
        variant: `text.${HeadingRegularVariants.sixth}`,
        color: "black.1",
        textDecoration: "none",
        ":hover": {
            color: "grey.3"
        },
        "&.active > a": {
            color: "blue.0"
        }
    },
    [LinkVariants.footer]: {
        transition: "all 0.1s ease-in",
        variant: "text.label2",
        color: "white.0",
        textDecoration: "none",
        ":hover": {
            color: "white.0",
            textDecoration: "underline"
        }
    },
    [LinkVariants.copyright]: {
        color: "grey.1",
        textDecoration: "underline"
    },
    [LinkVariants.nonUnderlined]: {
        fontFamily: "label",
        fontWeight: "labelRegular",
        lineHeight: "label",
        fontSize: "1rem",
        color: "blue.0",
        textDecoration: "none"
    },
    [LinkVariants.breadcrumb]: {
        variant: "text.label2",
        color: "grey.1",
        height: 16,
        listStyle: "none",
        a: {
            color: "inherit",
            textDecoration: "none"
        },
        ":hover": {
            color: "blue.0"
        },
        "&.active > a": {
            color: "blue.0"
        }
    },
    [LinkVariants.card]: {
        variant: `text.${TextVariants.technicalParagraphLarge}`,
        color: "inherit",
        textDecoration: "underline",
        transition: "color opacity 0.1s ease",
        ":hover": {
            color: "inherit",
            opacity: 0.8
        },
        "&.active > a": {
            color: "blue.0"
        }
    },
    [LinkVariants.primaryButton]: Object.assign(Object.assign({ color: "white.0", bg: "blue.2", zIndex: 0 }, buttonStyles), { ":hover": {
            bg: "blue.0"
        }, ":active": {
            bg: "blue.2"
        }, "&:after": {
            background: `linear-gradient(66deg, ${rawColorValues[Colors.blue][0]}, ${rawColorValues[Colors.blue][2]}, ${rawColorValues[Colors.black][1]})`,
            animation: `${buttonLoadingEffect} 5s linear infinite`
        }, "&:hover:after": {} })
};
//# sourceMappingURL=links.js.map